import { render } from "./project_detail.vue?vue&type=template&id=0caac74a&scoped=true"
import script from "./project_detail.vue?vue&type=script&lang=js"
export * from "./project_detail.vue?vue&type=script&lang=js"

import "./project_detail.vue?vue&type=style&index=0&id=0caac74a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caac74a"]])

export default __exports__